<template>
  <RegistrationForm @submit="handleSubmit">
    <template slot="header">
      <FormHeader>Зарегистрироваться на вебинар</FormHeader>
      <FormHeader v-if="webinarSpecifics.preOpened" tag="h4">После регистрации Вы сможете задать свой вопрос в личном кабинете на странице вебинара</FormHeader>
    </template>

    <div class="alert alert-info">
      Всем участникам вебинара, подписанным на новостную рассылку Онлайн-школы, будет отправлена запись вебинара на email.
    </div>

    <template slot="checkboxes">
      <CheckboxInput name="remind_via_sms" v-model="smsReminder" :disabled="submitting || submitted">СМС напоминание о старте вебинара</CheckboxInput>
    </template>
  </RegistrationForm>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    computed: {
      ...mapState([
        'interestId',
        'interestType',
        'submitting',
        'submitted',
        'webinarSpecifics',
      ]),
    },

    data () {
      return {
        smsReminder: true,
      };
    },

    methods: {
      ...mapActions(['submit']),

      handleSubmit ({ email, name, phone, gdprConfirmed, newsletter, recaptchaResponse }) {
        const { interestId, interestType, smsReminder } = this;

        this.submit({
          email,
          name,
          phone,
          gdprConfirmed,
          newsletter,
          recaptchaResponse,
          interestId,
          interestType,
          interestOptions: {
            smsReminder: smsReminder,
          },
        });
      },
    },
  };
</script>

<style scoped>
  .alert.alert-info {
    background: #e9ebf5;
    padding: 10px 20px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1rem;
    color: #45517d;
    font-weight: 400;
    text-align: center;
  }
</style>
